import type { Ref } from 'vue'

import { onBeforeUnmount, onMounted, ref } from 'vue'

/**
 * Checks if an element exists in the DOM using a CSS selector.
 * It refreshes the check on Turbolinks load events.
 * @param selector CSS selector to check for element existence
 * @returns A ref that indicates if the element exists
 */
export default function useElementExistence(selector: string): Ref<boolean> {
  const elementExists = ref(false)

  function checkElementExistance(): void {
    const element = document.querySelector<HTMLMetaElement>(selector)
    elementExists.value = !!element
  }

  onMounted(() => {
    checkElementExistance()
  })

  const unsubscribe = window.onDomLoad(checkElementExistance)

  onBeforeUnmount(() => {
    if (unsubscribe) {
      unsubscribe()
    }
  })

  return elementExists
}
